import StockcarsAPI from 'api-client/StockCars'
import StoreConnector from '@/helpers/StoreConnector'
import { EventBus } from '@/plugins/event-bus'

const StockCarsService = {
  async getStockCars(
    search,
    reservationStatus,
    size,
    page,
    includeNationWide,
    syntecReserved,
    orderBy = 'komnumber',
    orderDirection = 'asc'
  ) {
    try {
      const result = await StockcarsAPI.getStockcars({
        search,
        reservationStatus,
        size,
        page,
        includeNationWide,
        syntecReserved,
        orderBy,
        orderDirection,
      })
      StoreConnector.dispatch('stockcars/addStockCars', result)
      return Promise.resolve(result?.length || 0)
    } catch (e) {
      EventBus.$emit('notification-warning', 'StockCarsGetFailed')
      return Promise.resolve()
    }
  },
  async getStockCarByKomnumber(komNumber) {
    try {
      const result = await StockcarsAPI.getStockcars({
        search: komNumber,
        reservationStatus: [],
        size: 1,
        page: 1,
        includeNationWide: true,
        syntecReserved: null,
      })

      if (result?.length > 0) {
        return result[0]
      } else {
        EventBus.$emit('notification-warning', 'StockCarsGetFailed')
        return null
      }
    } catch (e) {
      EventBus.$emit('notification-warning', 'StockCarsGetFailed')
      return Promise.resolve()
    }
  },
  async getStockCarIdFromCommissionNumber(komNumber) {
    try {
      const result = await StockcarsAPI.getStockCarIdFromCommissionNumber(komNumber)

      if (result) {
        return result
      }

      EventBus.$emit('notification-warning', 'StockCarsGetFailed')
      return null
    } catch (e) {
      EventBus.$emit('notification-warning', 'StockCarsGetFailed')
      return Promise.resolve()
    }
  },
  async getStockIdFromCommissionNumber(commissionNumber) {
    try {
      const result = await StockcarsAPI.getStockIdFromCommissionNumber(commissionNumber)

      if (result) {
        return result
      }

      EventBus.$emit('notification-warning', 'StockCarsGetFailed')
      return null
    } catch (e) {
      EventBus.$emit('notification-warning', 'StockCarsGetFailed')
      return Promise.resolve()
    }
  },
  async resetStockCars() {
    await StoreConnector.dispatch('stockcars/reset')
  },
  async setStockCarReservation(params) {
    try {
      const result = await StockcarsAPI.setStockCarReservation(params)

      if (result) {
        return result
      }

      return null
    } catch (e) {
      return Promise.resolve()
    }
  },
}

export default StockCarsService
